import { getMicroserviceBaseContext } from '../../constants/api-routing';

const searchContext = getMicroserviceBaseContext('search');

export const SEARCH_SERVICE = {
    getSearchResponse: `${searchContext}search`,
    uploadDocument: `${searchContext}upload_document`,
}
